"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _range2 = _interopRequireDefault(require("lodash/range"));

var _downloadjs = _interopRequireDefault(require("downloadjs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var heatmapDataIntoLinesOfData = function heatmapDataIntoLinesOfData(heatmapData, placeholder) {
  var heatmapDataAsMatrix = (0, _range2["default"])(heatmapData.yAxisCategories.length).map(function () {
    return (0, _range2["default"])(heatmapData.xAxisCategories.length).map(function () {
      return placeholder;
    });
  });
  heatmapData.dataSeries.forEach(function (series) {
    series.data.forEach(function (point) {
      heatmapDataAsMatrix[point.y][point.x] = point.value;
    });
  });
  return [[""].concat(heatmapData.xAxisCategories.map(function (header) {
    return header.label;
  }))].concat(heatmapData.yAxisCategories.map(function (rowLabel, ix) {
    return [].concat.apply([rowLabel.label], heatmapDataAsMatrix[ix]);
  })).map(function (line) {
    return line.join("\t");
  });
};

var CommenceDownload = function CommenceDownload(_ref) {
  var name = _ref.name,
      descriptionLines = _ref.descriptionLines,
      heatmapData = _ref.heatmapData,
      isSingleExperiment = _ref.isSingleExperiment;
  (0, _downloadjs["default"])(new Blob(["# Downloaded from: ".concat(window.location.href), "# Timestamp: ".concat(new Date().toISOString())].concat(_toConsumableArray(descriptionLines.map(function (line) {
    return "# ".concat(line);
  })), _toConsumableArray(heatmapDataIntoLinesOfData(heatmapData, isSingleExperiment ? "" : "NA"))).map(function (line) {
    return "".concat(line, "\n");
  })), "".concat(name.replace(/ +/, "_"), ".tsv"), "text/tsv");
};

var _default = CommenceDownload;
exports["default"] = _default;